import { withoutBody } from "@/lib/blog";
import type { GetStaticPaths, GetStaticProps } from "next";
import Layout from "@/components/Layout";
import PageTitle from "@/components/PageTitle";
import BlogCard from "@/components/BlogCard";
import { getPosts } from "@/lib/cms";
import { slugifyCategory, type BlogPost } from "@/lib/blog";

// Preserves $route['blog-author/(:any)'] from the CodeIgniter routes file.

type Props = { posts: BlogPost[]; author: string };

export default function BlogAuthor({ posts, author }: Props) {
  return (
    <Layout
      route={`/blog/blog-author/${slugifyCategory(author)}`}
      seo={{
        title: `Articles by ${author} | Chest Surgery India`,
        description: `Blog posts written by ${author} for Chest Surgery India.`,
        canonical: `/blog/blog-author/${slugifyCategory(author)}`,
      }}
    >
      <PageTitle title={author} crumb={author} />
      <section className="blog-area-two pt-100">
        <div className="container">
          <div className="row">
            {posts.map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = await getPosts();
  const authors = new Set(posts.map((p) => p.author).filter(Boolean));
  return {
    paths: [...authors].map((a) => ({ params: { author: slugifyCategory(a) } })),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<Props, { author: string }> = async ({ params }) => {
  const all = await getPosts();
  const match = all.find((p) => slugifyCategory(p.author) === params!.author);
  if (!match) return { notFound: true };

  return {
    props: {
      author: match.author,
      posts: all.filter((p) => slugifyCategory(p.author) === params!.author).map(withoutBody),
    },
  };
};
